import React from 'react';
import { HashRouter } from 'react-router-dom';
import GeneralRouter from './GeneralRouter';
import { AgentChatPanelGated } from '../components/AgentChat';

const AppRouter: React.FC = () => {
    return (
        <HashRouter>
            <GeneralRouter />
            {/* Mounted inside the router so the agent FAB can read the active
                route via useLocation (e.g. to gate plan auto-catch to Review &
                Publish). It sits alongside <Routes>, so it persists across route
                changes without remounting. */}
            <AgentChatPanelGated />
        </HashRouter>
    );
};

export default AppRouter;
